import { Topbar } from "@/components/Topbar";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="font-display font-semibold text-xl text-[#1a1d20] mb-3">{title}</h2>
    <div className="text-[#1a1d20]/70 text-sm sm:text-base leading-relaxed space-y-2">{children}</div>
  </div>
);

export const LegalLayout = ({ title, testid, children }) => (
  <div data-testid={testid}>
    <Topbar />
    <Header />
    <main className="bg-[#f6f5f2] py-20 sm:py-28 min-h-[60vh]">
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <p className="font-display text-[#e2001a] font-semibold tracking-[0.28em] uppercase text-xs mb-4 flex items-center gap-3">
          <span className="inline-block w-8 h-[2px] bg-[#e2001a]" />
          Rechtliches
        </p>
        <h1 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-[#1a1d20] tracking-tight mb-12">{title}</h1>
        {children}
        <p className="mt-14 text-xs text-[#1a1d20]/45 border-t border-[#1a1d20]/10 pt-6">
          Hinweis: Dies ist ein Template. Bitte ergänzen Sie die vollständigen Unternehmens- und Rechtsdaten.
        </p>
      </div>
    </main>
    <Footer />
  </div>
);

export { Section };
